import { render, staticRenderFns } from "./mastermodelpinjaman.vue?vue&type=template&id=588bf67a&"
import script from "./mastermodelpinjaman.vue?vue&type=script&lang=js&"
export * from "./mastermodelpinjaman.vue?vue&type=script&lang=js&"
import style0 from "./mastermodelpinjaman.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports